<template>

<div>
  <el-row type="flex" justify="space-start" :gutter="20">
    <el-col :span="12">
      <el-card class="box-card">
        <div class="card-content">
          <h4 class="card-title">Details</h4>
          <el-form :model="product" ref="product" label-width="120px">
                <el-row>
                  <el-form-item label="Name">
                    <el-input label="Name" v-model="product.name"></el-input>
                  </el-form-item>
                  <el-form-item label="Description" >
                    <el-input label="Description" v-model="product.description"></el-input>
                  </el-form-item>
                  <el-form-item label="Type">
                    <el-input label="Type" v-model="product.type" ></el-input>
                  </el-form-item>
                  <el-form-item label="Cost (GBP)" v-if="currentPrice.prices.length == 0">
                    <el-input label="Cost (GBP)" v-model="product.cost" ></el-input>
                  </el-form-item>
                  <el-form-item label="Default Cost" v-else>
                    <el-input label="Default Cost" disabled v-model="product.cost" ></el-input>
                    <small>Overwritten by regional pricing</small>
                  </el-form-item>
                  <el-form-item label="Certificate Text">
                    <el-input type="textarea" label="Certificate text" v-model="product.certificateText"></el-input>
                  </el-form-item>
                  <el-form-item label="Certificate Small Text">
                    <el-input type="textarea" rows="4" label="Certificate small text" v-model="product.certificateSmallText"></el-input>
                  </el-form-item>
                  <el-form-item label="URL">
                    <el-input label="URL" v-model="product.URL" ></el-input>
                  </el-form-item>
                  <el-form-item label="Image URL">
                    <el-input label="Image URL" v-model="product.imageURL" ></el-input>
                  </el-form-item>
                  <br />
                  <h5>Learning Outcomes</h5>
                  <small>Appears on the certificate page 2</small>
                  <VuePellEditor 
                    
                    v-model="product.learningOutcomes"
                    :style-with-css="false"
                    default-paragraph-separator="p"
                  />
                  <br />
                       <br />
                  <h5>Additional Info</h5>
                  <small>Appears in the sts dashboard</small>
                  <VuePellEditor 
                    
                    v-model="product.additionalInfo"
                    :style-with-css="false"
                    default-paragraph-separator="p"
                  />
                </el-row>
          </el-form>
        </div>

        <el-button type="primary" @click="updateProduct()">Save</el-button><br><br>

      </el-card>
    </el-col>

    <el-col :span="12">

      <el-card class="box-card">
          <div class="card-header">
            <h4 class="card-title">Mailchimp details</h4>
          </div>
          <div class="card-content" v-if="mcProduct.description">
            <el-form :model="mcProduct" ref="product" label-width="120px">
                <el-row>
                  <el-form-item label="Name">
                    <el-input label="Name" v-model="mcProduct.title"></el-input>
                  </el-form-item>
                  <el-form-item label="Description" >
                    <el-input label="Description" v-model="mcProduct.description"></el-input>
                  </el-form-item>
                  <el-form-item label="Type">
                    <el-input label="Type" v-model="mcProduct.type" ></el-input>
                  </el-form-item>
                </el-row>
          </el-form>
        </div>
        <div class="card-content" v-else>
          <el-button type="primary" @click="mcSync()">Create product in Mailchimp</el-button>    
        </div>
      </el-card>

      <el-card class="box-card" style="margin-top:30px;">
          <div class="card-header">
            <h4 class="card-title">New Pricing</h4>
          </div>
          <div class="card-content">
          <el-row>
            <el-col :span="12">

                <h5>Label</h5>

                  <el-select
                    size="large"
                    class="form-group border-input"
                    placeholder="Select Pricelabel"
                    v-model="newPrice.label"
                  >
                    <el-option
                      v-for="label in priceLabels"
                      class="select-danger"
                      :value="label"
                      :label="label"
                      :key="label"
                    ></el-option>
                  </el-select>

            </el-col>

            <el-col :span="12">
                
                <h5>Cost</h5>
                <el-input-number v-model="newPrice.cost" :min="1" :max="99999"></el-input-number>    
      

            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">

                    <h5 class="card-title">Choose when new price starts and ends</h5>
                    <el-date-picker
                      v-model="newPrice.dateFrom"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="Pick a start date">
                    </el-date-picker>
                    <el-date-picker
                      v-model="newPrice.dateTo"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="Pick an end date">
                    </el-date-picker>

                          
            </el-col>
          </el-row>
          <br />
 <el-button type="primary"  @click="insertPrice">Save Price</el-button>
        </div>
      </el-card>
      
      <el-card class="box-card" v-if="currentPrice.prices.length > 0" style="margin-top:30px;">
          <div class="card-header">
            <h4 class="card-title">Change Pricing</h4>
          </div>
          <div class="card-content">
            <el-col :span="8">
            <div v-for="price in currentPrice.prices" :key="price.id">

                  <h5 class="card-title">{{price.label}}</h5>
                  <el-input-number v-model="price.cost" :min="1" :max="99999" :label="price.label"></el-input-number>    
                  <hr>      

            </div>
            </el-col>
            <el-col :span="16">
              <div v-for="date in currentPrice.prices" :key="date.id">
                    <h5 class="card-title">Choose when new prices starts and ends</h5>
                    <el-date-picker
                      v-model="date.dateFrom"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="Pick a start date">
                    </el-date-picker>
                    <el-date-picker
                      v-model="date.dateTo"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="Pick an end date">
                    </el-date-picker>
                    <hr>
              </div>
                          
            </el-col>
            <div class="text-center">
                <el-button v-for="(price, index) in currentPrice.prices" :key="price.id" :type="colours[index]" @click="updatePrice(price.id,index)">Update {{currentPrice.prices[index].label}} price</el-button>
                </div>  
        </div>
      </el-card>

      <el-card v-else class="box-card" style="margin-top:30px;">
          <div class="card-header">
            <h4 class="card-title">Regional pricing not set</h4>
            <h5>GBP Cost: £{{product.cost}}</h5>
            <p>Please edit using field in product details section</p>
          </div>
      </el-card>

    </el-col>
  </el-row>

  <el-row v-if="currentPrice.prices.length > 0" type="flex" justify="space-start" :gutter="20">
    <el-col :span="24" style="margin-top:30px;">
      <el-card class="box-card">
        <div class="card-content">
          <div class="card-header">
          <h4 class="card-title">Existing price changes</h4>
          <p class="category"></p>
          <br>
          </div>
              <div class="table-responsive">
                <el-table class="table-shopping" style="width: 100%" :data="product.prices">
                      <el-table-column
                        label="Live"
                        min-width="50">
                        <template slot-scope="props">
                          <small class="label label-success" v-if="props.row.dateTo >= now && props.row.dateFrom <= now"><i class="fa fa-check"></i> Live</small>
                        </template>
                      </el-table-column>
                      <el-table-column 
                        prop="cost" 
                        label="Price" 
                        min-width="50">  
                      </el-table-column>
                      <el-table-column
                        prop="label"
                        label="Site"
                        min-width="50">
                      </el-table-column>
                      <el-table-column
                        prop="dateFrom"
                        label="From Date"
                        min-width="120">
                      </el-table-column>
                      <el-table-column
                        prop="dateTo"
                        label="To Date"
                        min-width="120">
                      </el-table-column>
                </el-table>
            </div>

        </div>
      </el-card>
    </el-col>
  </el-row>
</div>




</template>


<script>
import api from "./api";
import gql from "graphql-tag";
import { debug } from 'util';
import _ from 'lodash';
import stores from "../../data/mcstores.json";
import moment from "moment";
import VuePellEditor from 'vue-pell-editor';

export default {
  components: {
    VuePellEditor
  },

  data() {
    return {
      product: {},
      mcProduct: {},
      newPrice: {
        label: 'TEFLORG'
      },
      storeIds: stores,
      currentPrice: {
        prices: []
      },
      now: moment().format(),
      colours: [
        'danger',
        'primary',
        'success'
      ],
      priceLabels: [
        'TEFLORG',
        'TEFLUS',
        'IRELAND',
        'AUSTRALIA',
        'SOUTHAFRICA',
        'CANADA'
      ]
    };
  },



 methods: {

   getMcProduct(id) {
      api
        .getProduct(4,id)
        .then(response => {
          console.log(response);
          this.mcProduct = response.data; 
          console.log(this.mcProduct);
        });
    },

    updateMcProduct(data) {
      console.log('data: ',data);
      api
        .updateProduct(data)
        .then(response => {
          console.log(response);
          this.mcProduct = response.data; 
          console.log(this.mcProduct);
        });
    },

    mcSync() {
      if (this.currentPrice.prices.length > 0) {
        for (let i = 0; i < this.currentPrice.prices.length; i++) {
          this.createMcProduct({
            storeId: this.storeIds[this.currentPrice.prices[i].label],
            product:{
              id:this.product.id,
              name:this.product.name,
              description:this.product.description,
              type:this.product.type,
              price:this.currentPrice.prices[i].cost
            }
          })
        }
      } else {
        this.createMcProduct({
            storeId: 1,
            product:{
              id:this.product.id,
              name:this.product.name,
              description:this.product.description,
              type:this.product.type,
              price:this.product.cost
            }
          })  
      }
    },

    createMcProduct(data) {
      console.log('data: ',data);
      api
        .createProduct(data)
        .then(response => {
          console.log(response);
          this.mcProduct = response.data; 
          console.log(this.mcProduct);
        });
    },

    getProduct(id) {

        this.$apollo
          .query({
            query: gql` {
        Product_by_pk(id: ${id}) {
          id
          name
          description
          type
          certificateText
          certificateSmallText
          learningOutcomes
          additionalInfo
          cost
          URL
          imageURL
          prices
           {
            id
            cost
            label
            dateFrom
            dateTo
          }
        }
      }`,
            
        })
        .then(response => {
          this.product = response.data.Product_by_pk;
        })
      },

      getCurrentPrices(currentDate, id) {

        this.$apollo
          .query({
            query: gql` {
        Product_by_pk(id: ${id}) {
          id
          prices (where: {_and: {dateFrom: {_lte: "${currentDate}"}, dateTo: {_gte: "${currentDate}"}}})
           {
            id
            cost
            label
            dateFrom
            dateTo
          }
        }
      }`,
            
        })
        .then(response => {
          this.currentPrice = response.data.Product_by_pk;
          //console.log('currentPrice',this.currentPrice);
        })
      },

      updatePrice(id,index){
        const q = gql`
          mutation update_product($id: Int, $cost: float8, $dateFrom: date, $dateTo: date) {
            update_ProductPrice(where: {id: {_eq: $id}}, _set: {cost: $cost, dateFrom: $dateFrom, dateTo: $dateTo}){
              affected_rows
              returning {
                id
                cost
                dateFrom
                dateTo
              }
            }
          }
        `

        this.$apollo

        .mutate({
          mutation: q,
          variables: {
            id: this.currentPrice.prices[index].id,
            cost: this.currentPrice.prices[index].cost,
            dateFrom: this.currentPrice.prices[index].dateFrom,
            dateTo: this.currentPrice.prices[index].dateTo
          }
        })

        .then(result => {
          this.$notify({
            title: "Update Product Price",
            message: "Product Price Updated",
            type: "success"
          });
          this.updateMcProduct({
            storeId: this.storeIds[this.currentPrice.prices[index].label],
            product:{
              id:this.product.id,
              name:this.product.name,
              description:this.product.description,
              type:this.product.type,
              price:this.currentPrice.prices[index].cost,
            }
          })
          // return result
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
      },

      insertPrice(){
        const q = gql`
          mutation insert_productPrice($label: String, $productId: Int, $cost: float8, $dateCreated: timestamptz, $dateFrom: date, $dateTo: date) {
            insert_ProductPrice(objects: {label: $label, productId: $productId, cost: $cost, dateCreated: $dateCreated, dateFrom: $dateFrom, dateTo: $dateTo}) {
              affected_rows
              returning {
                id
                cost
                dateCreated
                dateFrom
                dateTo
                dateUpdated
                label
                productId
              }
            }
          }
        `

        this.$apollo

        .mutate({
          mutation: q,
          variables: {
            label: this.newPrice.label,
            productId: this.product.id,
            cost: this.newPrice.cost,
            dateCreated: this.now,
            dateFrom: this.newPrice.dateFrom,
            dateTo: this.newPrice.dateTo
          }
        })

        .then(result => {
        
          this.$notify({
            title: "New Product Price",
            message: "Product Price Added",
            type: "success"
          }); 
            this.getProduct(this.product.id);
           this.getCurrentPrices(this.currentDate, this.$route.params.id)
          this.updateMcProduct({
            storeId: this.storeIds[this.newPrice.label],
            product:{
              id:this.product.id,
              name:this.product.name,
              description:this.product.description,
              type:this.product.type,
              price:this.newPrice.cost,
            }
          });
        
          // return result
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
      },
      

      updateProduct(id){
      const q = gql`
        mutation update_product($id: Int, $changes: Product_set_input) {
          update_Product(where: { id: { _eq: $id } }, _set: $changes) {
            affected_rows
            returning {
              id
              name
            }
          }
        }
      `;

       this.$apollo
        /// You must strip out the nested objects and only send the product object
        .mutate({
          mutation: q,
          variables: {
            id: this.product.id,
            changes: _.omit(this.product, [
              "prices",
              "__typename"
            ])
          }
        })
        .then(result => {
          this.$notify({
            title: "Updated Product Details",
            message: "Product Updated",
            type: "success"
          });
          if (this.currentPrice.prices.length > 0) {
            for (let i = 0; i < this.currentPrice.prices.length; i++) {
              this.updateMcProduct({
                storeId: this.storeIds[this.currentPrice.prices[i].label],
                product:{
                  id:this.product.id,
                  name:this.product.name,
                  description:this.product.description,
                  type:this.product.type,
                  price:this.currentPrice.prices[i].cost
                }
              })
            }
          } else {
            this.updateMcProduct({
                storeId: 1,
                product:{
                  id:this.product.id,
                  name:this.product.name,
                  description:this.product.description,
                  type:this.product.type,
                  price:this.product.cost
                }
              })  
          }
          //return result;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
},
    
  },

  computed: {
        currentDate: function() {
          var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

          if (month.length < 2) month = '0' + month;
          if (day.length < 2) day = '0' + day;

          return [year, month, day].join('-');
        },
        
  },


  mounted() {
    this.getCurrentPrices(this.currentDate, this.$route.params.id);
    this.getProduct(this.$route.params.id);
    this.getMcProduct(this.$route.params.id);
  },

  watch: {  
    '$route.params.id': function(id) {
      this.getCurrentPrices(id)
    }

},


}
</script>


// WEBPACK FOOTER //
// src/components/Products/Edit.vue